import { Component, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SAAS_BASE_PLAN, SAAS_USERS } from '../../../services/saas-pricing';

interface Addon {
  name: string;
  desc: string;
  price: string;
}

/**
 * Bloque de precios de la home (diseño "Híbrido v2"): un solo precio con toggle
 * mensual/anual, tarjeta base "Esencial" + panel de ampliaciones (usuario
 * completo / módulo / complemento) y ancla del Consejo de Estado. Los importes
 * salen de saas-pricing.ts (fuente única del precio base).
 */
@Component({
  selector: 'app-home-precios',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home-precios.component.html',
  styleUrl: './home-precios.component.scss',
})
export class HomePreciosComponent {
  readonly base = SAAS_BASE_PLAN; // monthly 45, annualMonths 10

  billing = signal<'monthly' | 'annual'>('monthly');
  setBilling(b: 'monthly' | 'annual'): void {
    this.billing.set(b);
  }

  // En anual se muestra el total del año (450 €/año), nunca un equivalente
  // mensual ni tachados/porcentajes (regla del handoff v2).
  amountText = computed(() =>
    this.billing() === 'annual'
      ? String(this.base.monthly * this.base.annualMonths)
      : String(this.base.monthly)
  );

  perText = computed(() => (this.billing() === 'annual' ? '/año' : '/mes'));

  subline = computed(() =>
    this.billing() === 'annual'
      ? 'dos meses sin coste · IVA no incluido'
      : 'por empresa · IVA no incluido'
  );

  features = [
    'Operativos ilimitados',
    '1 usuario completo incluido',
    'Fichaje, facturación, clientes, gastos y calendario',
    'Sin permanencia · Verifactu de serie',
  ];

  addons: Addon[] = [
    {
      name: 'Usuario completo',
      desc: 'Gestiona, factura, ve el global y saca informes.',
      price: `+${SAAS_USERS.fullPrice} €/mes`,
    },
    {
      name: 'Módulo',
      desc: 'Capacidad nueva que funciona por sí sola.',
      price: '+8 €/mes',
    },
    {
      name: 'Complemento',
      desc: 'Potencia un módulo que ya tienes.',
      price: '+3 €/mes',
    },
  ];
}
